namespace $.$$ {
	$mol_style_define( $shm_ba_mention_stats_task, {
		flex: { grow: 1, shrink: 1 },
		minWidth: 0,
	} )
}
